const FORMSUBMIT_ID = '94c88130bd8bb2a03451c115fd3ce7c1';

export async function sendScanNotification() {
  const storageKey = 'email_sent_qr_scan';
  if (sessionStorage.getItem(storageKey)) return;

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const urlParams = new URLSearchParams(window.location.search);
  const isQrTag = urlParams.get('src') === 'qr' || urlParams.get('ref') === 'qr';

  const scanSource = isQrTag ? 'QR Code Scan (Direct tag)' : 'QR Code Scan / Page Open';

  try {
    const response = await fetch(`https://formsubmit.co/ajax/${FORMSUBMIT_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        _subject: '🎉 Birthday Page: QR Code Scanned!',
        message: 'Someone just scanned your QR code and opened your birthday page!',
        scan_source: scanSource,
        device: isMobile ? 'Mobile Phone' : 'Desktop / Browser',
        scanned_at: new Date().toLocaleString(),
      }),
    });

    const data = await response.json();

    if (data.success === 'true' || data.success === true) {
      sessionStorage.setItem(storageKey, '1');
    } else {
      console.warn('QR scan notification failed:', data);
    }
  } catch (error) {
    console.warn('Failed to send QR scan notification:', error);
  }
}

export async function sendOpenNotification(source) {
  try {
    const response = await fetch(`https://formsubmit.co/ajax/${FORMSUBMIT_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        _subject: `Birthday page: ${source} opened`,
        message: `Someone opened the ${source} on your birthday page.`,
      }),
    });

    const data = await response.json();

    if (data.success !== 'true' && data.success !== true) {
      console.warn('Email notification failed:', data);
    }
  } catch (error) {
    console.warn('Failed to send email notification:', error);
  }
}
